import {useState,useEffect}from"react";
import {Link} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import {countrys,states} from "../../../../../core/common/selectOption";
import ItemValueEdit from '../../item/itemValueEdit';
import ItemCustomFieldEdit from '../../item/itemCustomFieldEdit';
import ItemNoteEdit from '../../item/itemNoteEdit';
import ItemSettingEdit from '../../item/itemSettingEdit';
import Select from "react-select";
import {all_routes} from "../../../../../feature-module/router/all_routes";
import ImageUploading from 'react-images-uploading';
import {Toaster} from 'react-hot-toast';
import {UrlQuery} from "biz9-react-utility";
/* -- biz9 import start -- */
import {Image_Type,Image_Format,Image_Table,Image_Field,Image_Service,Image_Url,Image_Logic} from "biz9-image";
import {Str,Status_Type,Log} from "biz9-utility";
import {Data_Logic} from "biz9-data-app";
import {Page_Logic,Portal_Type,Portal_Url,Portal_Title,Sub_Value_Logic,Portal_Value_Type,Portal_Page,Portal_Remote_Page,Portal_Remote_Data,Portal_Remote_CMS,Portal_Table,Portal_Field,Portal_Remote_User,Portal_Remote_Image} from "biz9-portal-app";
import {User_Logic,User_Field,User_Table,User_Url,User_Service} from "biz9-user";
import {Message,Type,Url,Title,Config,Field} from "../../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,User,Toast_Message,Template,Storage,System} from "../../../../../project";
/* -- biz9 import end -- */
const Dashboard_App_User_Edit = () => {
    const query = UrlQuery();
    const [val_id,setValId] = useState(query.get('id'));
    const [val_sub_page_title,setValSubPageTitle] =  useState("");
    const [val_category,setValCategory] = useState(null);
    const [categorys,setCategorys] = useState([]);
    const [custom_fields,setCustomFields] = useState([]);
    const [field_values,setFieldValues] = useState([]);
    const [val_role,setValRole] = useState(null);
    const [roles,setRoles] = useState([]);
    const [val_note,setValNote] = useState("");
    const [val_username,setValUserName] = useState("");
    const [val_description,setValDescription] = useState("");
    const [val_first_name,setValFirstName] = useState("");
    const [val_last_name,setValLastName] = useState("");
    const [val_email,setValEmail] = useState("");
    const [val_password,setValPassword] = useState("");
    const [val_city,setValCity] = useState("");
    const [val_state,setValState] = useState(null);
    const [val_country,setValCountry] = useState(null);
    const [val_gender,setValGender] = useState(null);
    const [hide_btn_image_post,setHideBtnImagePost] = useState(false);
    const [images,setImages] = useState([]);
    const [image_primary,setImagePrimary] = useState([]);
    const image_max_count = 1;
    const [item,setItem] = useState(Data_Logic.get(Portal_Table.USER,val_id));
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            if(!Str.check_is_null(val_id)){
            get_data();
            }
            },[val_id]);
	async function get_data() {
        let [response,data] = await Portal_Remote_CMS.get(App.get_url(Portal_Url.CMS_GET),Portal_Table.USER,val_id,{category:Title.USER});
        bind_page(data[Portal_Type.ITEM]);
        bind_field(data[Portal_Type.ITEM]);
        bind_field_value(data[Portal_Type.ITEM]);
        bind_items(data);
        Toast_Message.dismiss();
    };
	async function bind_page(data) {
        setValSubPageTitle(data.title);
    };
    async function bind_field(data) {
        setItem(Data_Logic.clean(data));
        setValUserName(data.username);
        setValDescription(data.description);
        setValGender(data.gender);
        setValFirstName(data.first_name);
        setValPassword(data.password);
        setValLastName(data.last_name);
        setValEmail(data.email);
        setValPassword(data.password);
        setValCity(data.city);
        setValCountry(countrys.find(option => option.value === data.country));
        setValState(states.find(option => option.value === data.state));
        if(data.image_filename){
            setImagePrimary([{image_filename:data.image_filename}]);
            setHideBtnImagePost(true);
        }
    };
    async function bind_field_value(data) {
        setFieldValues(Data.bind_field_values(data));
    };
    async function bind_items(data){
        //catetory
        let set_categorys = Data.get_type_categorys(data[Portal_Type.CATEGORYS],{blank:true});
        setCategorys(set_categorys);
        setValCategory(set_categorys.find(option => option.label === data[Portal_Type.ITEM].category));
        //role
        let roles = User_Logic.get_user_roles();
        setRoles(roles);
        setValRole(roles.find(option => option.value === data[Portal_Type.ITEM].role));
    };
    const handle_submit = (event) =>{
        event.preventDefault();
    };
    const updateValUserName = (event) => {
        setValUserName(Str.get_title_url(event.target.value));
    };
    const updateValFirstName = (event) => {
        setValFirstName(event.target.value);
    };
    const updateValLastName = (event) => {
        setValLastName(event.target.value);
    };
    const updateValEmail = (event) => {
        setValEmail(event.target.value);
    };
    const updateValPassword = (event) => {
        setValPassword(event.target.value);
    };
    const updateValCategory = (selectedOption) => {
       setValCategory(selectedOption);
        post_field(item,Portal_Field.CATEGORY,selectedOption.label,{});
    };
    const updateValRole = (selectedOption) => {
        setValRole(selectedOption);
        post_field(item,User_Field.ROLE,selectedOption.value,{});
    };
    const updateValDescription = (event) => {
        setValDescription(event.target.value);
    };
    const updateValCity = (event) => {
        setValCity(event.target.value);
    };
    const updateValCountry = (selectedOption) => {
        setValCountry(selectedOption);
        post_field(item,User_Field.COUNTRY,selectedOption.label,{});
    };
    const updateValState = (selectedOption) => {
        setValState(selectedOption);
       post_field(item,User_Field.STATE,selectedOption.label,{});
    };
    const updateValGender = (event) => {
        setValGender(event.target.value);
        post_field(item,User_Field.GENDER,event.target.value,{});
    };
        async function onImagePrimaryChange(image_upload, addUpdateIndex){
        Toast_Message.loading(Message.SAVING);
        setHideBtnImagePost(true);
        let image = Data_Logic.get(Image_Table.IMAGE,0,{data:{base64:image_upload[0][Image_Field.BASE64],extension:Str.get_file_extension(image_upload[0][Image_Field.FILE][Image_Field.NAME])}});
        let [response,data] = await Portal_Remote_Image.post(App.get_url(Portal_Url.IMAGE_POST),[image]);
        if(response.status == Status_Type.SUCCESS){
            Toast_Message.success(response.message);
            setHideBtnImagePost(true);
            post_field(item,Image_Field.IMAGE_FILENAME,data[0].image_filename,{});
            setImagePrimary([data[0]]);
        }else{
            Toast_Message.error(response.message);
            setHideBtnImagePost(false);
        }
        Toast_Message.dismiss();
    };
    const onImagePrimaryDelete = () => {
        if (window.confirm(Message.CONFIRM)) {
            Toast_Message.loading(Message.DELETING);
            setHideBtnImagePost(false);
            setImagePrimary([]);
            post_field(item,Image_Field.IMAGE_FILENAME,'',{success_message:Message.DELETED});
        }
    };
   async function post_email_field(item,field,value,option){
        post_field(item,field,value,option);
   };
   async function post_field(item,field,value,option){
       // -- post-user-field --
        if(!value){
            value = '';
        }
        if(field == User_Field.TITLE && !Str.check_is_null(item[Portal_Field.TITLE])){
            item[Portal_Field.TITLE_URL] = Str.get_title_url(value);
        }
        option = option ? option : {required:false,success_message:''};
        if(value.trim() === '' && option.required) {
            Toast_Message.error(Message.INPUT_REQUIRED);
        }else{
            Toast_Message.loading(Message.SAVING);
            item[Portal_Field.PASSWORD] = val_password;
            item[Portal_Field.EMAIL] = val_email;
            item[Portal_Field.USERNAME] = val_username;
            Log.w('11_post_me',item);
            item[field] = value;
            Log.w('22_post_me',item);
            let option_post = {overwrite:true,clean:true};
            let [response,data] = await Portal_Remote_User.post(App.get_url(Portal_Url.USER_POST),item,option_post);
            Log.w('33_response',response);
            Log.w('33_data',data);
            if(!option.success_message){
                setItem(item);
                bind_page(item);
                Toast_Message.success(response.message);
            }else{
                Toast_Message.success(option.success_message);
            }
        }
    };
return (
            <>
            <Toaster />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="page-content content bg-light">
            <div className="row justify-content-center">
            <div className="col-lg-10">
            <div className="main-title mb-4">
            <h4>{val_sub_page_title}</h4>
            </div>
            <div className="settings-info bg-white">
            <ul className="nav nav-tabs nav-tabs-bottom mb-4">
            <li className="nav-item">
            <Link to={all_routes.dashboard_app_user} className="nav-link" >
            {Dashboard.get_dash_edit_item_back_link(Portal_Table.USER)}
            </Link>
            </li>
            </ul>

            <div className="settings-page-lists">
            <ul className="settings-head nav nav-tabs" role="tablist">
            <li className="nav-item" role="presentation">
            <Link to="#" className="nav-link active" data-bs-toggle="tab" data-bs-target="#tab_general"
            aria-selected="false" role="tab" tabIndex={-1}>
            {Title.LABEL_CMS_TAB_GENERAL}
    </Link>
        </li>
        <li className="nav-item" role="presentation">
        <Link to="#" className="nav-link" data-bs-toggle="tab" data-bs-target="#tab_field" aria-selected="false"
        role="tab" tabIndex={-1}>
        {Title.LABEL_CMS_TAB_CUSTOM_FIELD}
    </Link>
        </li>
        <li className="nav-item" role="presentation">
        <Link to="#" className="nav-link" data-bs-toggle="tab" data-bs-target="#tab_value" aria-selected="false"
        role="tab" tabIndex={-1}>
        {Title.LABEL_CMS_TAB_VALUE}
    </Link>
        </li>
        <li className="nav-item" role="presentation">
        <Link to="#" className="nav-link" data-bs-toggle="tab" data-bs-target="#tab_setting" aria-selected="false" role="tab"
        tabIndex={-1}>
        {Title.LABEL_CMS_TAB_SETTING}
    </Link>
        </li>
        </ul>
        </div>
        <div className="tab-content">
        {/* General Tab  */}
    <div className="tab-pane fade show active" id="tab_general" role="tabpanel">
        <div className="settings-card">
        <div className="settings-card-head bg-light">
        <h4>General</h4>
        </div>
        <form onSubmit={handle_submit}>
        <div className="settings-card-body">
        <div className="row">
        <div className="col-md-12">
        <div className="form-wrap">
        <ImageUploading
        value={image_primary}
    onChange={onImagePrimaryChange}
    maxNumber={image_max_count}
    dataURLKey={Image_Field.BASE64}>
    {({
            imageList,
            onImageUpload,
            onImageRemoveAll,
            onImageUpdate,
            isDragging,
            dragProps,
            }) => (
                <div className="upload__image-wrapper">
                <button hidden={hide_btn_image_post} className="btn btn-secondary mb-2"
                style={isDragging ? { color: 'red' } : undefined} onClick={() =>  onImageUpload()}
                {...dragProps} >
                Image
                </button>
                &nbsp;
                {imageList.map((image, index) => (
                            <div key={index} className="image-item">
                            <img  src={Image.get_url(image.image_filename,Image_Format.SQUARE_THUMB)} alt="" height="200" width="200" />
                            <div className="image-item__btn-wrapper">
                            <Link onClick={() => onImagePrimaryDelete()} to="#" className="mb-2" >
                            <FeatherIcon icon="trash-2" />
                            </Link>
                            </div>
                            </div>
                            ))}
                </div>
                )}
    </ImageUploading>
        </div>
        </div>
        <div className="col-md-12">
        <div className="form-wrap mb-3">
        <label className="mb-1 fw-medium text-dark">
        UserName{" "}
    <span className="text-primary">*</span>
        </label>
        <input value={val_username} onChange={updateValUserName} onBlur={() => post_field(item,User_Field.USERNAME,val_username,{required:true})} type="text" className="form-control" />
        </div>
        </div>

        <div className="col-md-4">
        <div className="form-wrap gig-option">
        <label className="mb-1 fw-medium text-dark d-block mb-2">
        {" "}
    Gender <span className="text-primary">*</span>
        </label>
        <label className="custom_radio">
        <input
        type="radio"
        name="gender"
        value="Male"
        checked={val_gender === 'Male'}
    onChange={updateValGender}
    />

        <span className="checkmark" />
        Male
        </label>
        <label className="custom_radio">

        <input
        type="radio"
        name="gender"
        value="Female"
        checked={val_gender === 'Female'}
    onChange={updateValGender}
    />

        <span className="checkmark" />
        Female
        </label>
        </div>
        </div>

        <div className="col-md-4">
        <div className="form-wrap">
        <label className="form-label mb-1 fw-medium text-dark">
        Category
        </label>
        <Select classNamePrefix="react-select" className="select" styles={Style.customStyles} options={categorys} value={val_category} onChange={updateValCategory} />
        </div>
        </div>

        <div className="col-md-4">
        <div className="form-wrap">
        <label className="form-label mb-1 fw-medium text-dark">
        Role
        </label>
        <Select classNamePrefix="react-select" className="select" styles={Style.customStyles} options={roles} value={val_role} onChange={updateValRole} />
        </div>
        </div>

        <div className="col-md-12">
        <div className="form-wrap mb-3">
        <label className="mb-1 fw-medium text-dark">
        First Name{" "}
    <span className="text-primary">*</span>
        </label>
        <input value={val_first_name} onChange={updateValFirstName} onBlur={() => post_field(item,User_Field.FIRST_NAME,val_first_name,{})} type="text" className="form-control" />
        </div>
        </div>
        <div className="col-md-12">
        <div className="form-wrap mb-3">
        <label className="mb-1 fw-medium text-dark">
        Last Name{" "}
    <span className="text-primary">*</span>
        </label>
        <input value={val_last_name} onChange={updateValLastName}  onBlur={() => post_field(item,User_Field.LAST_NAME,val_last_name,{})} type="text" className="form-control" />
        </div>
        </div>

        <div className="col-md-12">
        <div className="form-wrap mb-3">
        <label className="mb-1 fw-medium text-dark">
        Email{" "}
    <span className="text-primary">*</span>
        </label>
        <input value={val_email} onChange={updateValEmail} type="text" onBlur={() => post_email_field(item,User_Field.EMAIL,val_email,{})} className="form-control" />
        </div>
        </div>

    <div className="col-md-12">
        <div className="form-wrap mb-3">
        <label className="mb-1 fw-medium text-dark">
        Password{" "}
    <span className="text-primary">*</span>
        </label>
        <input value={val_password} onChange={updateValPassword} type="password" onBlur={() => post_field(item,User_Field.PASSWORD,val_password,{})} className="form-control" />
        </div>
        </div>




        <div className="col-md-4">
        <div className="form-wrap">
        <label className="form-label mb-1 fw-medium text-dark">
        City<span className="text-primary">*</span>
        </label>
        <input  value={val_city} onChange={updateValCity} type="text" onBlur={() => post_field(item,User_Field.CITY,val_city,{})} className="form-control" />
        </div>
        </div>

        <div className="col-md-4">
        <div className="form-wrap">
        <label className="form-label mb-1 fw-medium text-dark">
        Country<span className="text-primary">*</span>
        </label>
        <Select
        classNamePrefix="react-select"
        className="select"
        styles={Style.customStyles}
    options={countrys}
    value={val_country}
    onChange={updateValCountry}
    />
        </div>
        </div>

        <div className="col-md-4">
        <div className="form-wrap">
        <label className="form-label mb-1 fw-medium text-dark">
        State<span className="text-primary">*</span>
        </label>
        <Select
        classNamePrefix="react-select"
        className="select"
        styles={Style.customStyles}
    options={states}
    value={val_state}
    onChange={updateValState}
    />
        </div>
        </div>
        <div className="col-md-12">
        <div className="form-wrap mb-3">
        <label className="mb-1 fw-medium text-dark">
        {" "}
    Description{" "}
    </label>
        <input value={val_description} onChange={updateValDescription} onBlur={() => post_field(item,Field.DESCRIPTION,val_description,{})} type="text" className="form-control" />
        </div>
        </div>
        </div>
        </div>
        </form>
        </div>
        </div>
        {/* /General Tab  */}
    {/* Field Tab */}
    <div className="tab-pane fade" id="tab_field" role="tabpanel">
        <ItemCustomFieldEdit custom_fields={custom_fields} item={item} onItemUpdate={post_field} toast_loading={Toast_Message.loading} toast_success={Toast_Message.success} toast_error={Toast_Message.error} toast_dismiss={Toast_Message.dismiss} />
        </div>
        {/* Field Tab */}
    {/* Value Tab */}
    <div className="tab-pane fade" id="tab_value" role="tabpanel">
        <ItemValueEdit field_values={field_values} item={item} onFieldValuesUpdate={setFieldValues} onUpdate={setItem} toast_loading={Toast_Message.loading} toast_success={Toast_Message.success} toast_error={Toast_Message.error} toast_dismiss={Toast_Message.dismiss} />
        </div>
        {/* Value Tab */}
    {/* Note Tab */}
    <div className="tab-pane fade" id="tab_note" role="tabpanel">
        <ItemNoteEdit item={item} onItemUpdate={post_field} toast_loading={Toast_Message.loading} toast_success={Toast_Message.success} toast_error={Toast_Message.error} toast_dismiss={Toast_Message.dismiss} />
        </div>
        {/* Note Tab */}
    {/* Setting Tab */}
    <div className="tab-pane fade" id="tab_setting" role="tabpanel">
        <ItemSettingEdit item={item} onItemUpdate={post_field} toast_loading={Toast_Message.loading} toast_success={Toast_Message.success} toast_error={Toast_Message.error} toast_dismiss={Toast_Message.dismiss} />
        </div>
        {/* Setting Tab */}
    </div>
    {/* /Page Content */}
    </div>
        </div>
        </div>
        </div>
        </div>
        {/* /Page Content */}
    </>
        );
};
export default Dashboard_App_User_Edit;
